import React from "react";
import { motion } from 'framer-motion';

const brandsData = [
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/75/Django_logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/75/Django_logo.svg",
    altText: "Django",
    link: "#",
    color: "#092D1F", // Django's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
    altText: "Python",
    link: "#",
    color: "#306998", // Python's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/2/21/Matlab_Logo.png",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/2/21/Matlab_Logo.png",
    altText: "MATLAB",
    link: "#",
    color: "#0076A8", // MATLAB's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
    altText: "PyTorch",
    link: "#",
    color: "#EE4C2C", // PyTorch's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
    altText: "JavaScript",
    link: "#",
    color: "#F7DF1E", // JavaScript's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
    altText: "React",
    link: "#",
    color: "#61DAFB", // React's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
    altText: "TypeScript",
    link: "#",
    color: "#3178C6", // TypeScript's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/73/Ruby_logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/73/Ruby_logo.svg",
    altText: "Ruby",
    link: "#",
    color: "#CC342D", // Ruby's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg",
    altText: "PHP",
    link: "#",
    color: "#777BB4", // PHP's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg",
    altText: "Java",
    link: "#",
    color: "#007396", // Java's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
    altText: "C++",
    link: "#",
    color: "#00599C", // C++'s color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Swift_logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Swift_logo.svg",
    altText: "Swift",
    link: "#",
    color: "#F05138", // Swift's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/0/05/Go_Logo_Blue.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/0/05/Go_Logo_Blue.svg",
    altText: "Go",
    link: "#",
    color: "#00ADD8", // Go's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.png",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.png",
    altText: "Kotlin",
    link: "#",
    color: "#7F52FF", // Kotlin's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Rust_programming_language_black_logo.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Rust_programming_language_black_logo.svg",
    altText: "Rust",
    link: "#",
    color: "#000000", // Rust's color
  },
  {
    imageSrc: "https://upload.wikimedia.org/wikipedia/commons/3/39/Scala-full-color.svg",
    lightImageSrc: "https://upload.wikimedia.org/wikipedia/commons/3/39/Scala-full-color.svg",
    altText: "Scala",
    link: "#",
    color: "#DC322F", // Scala's color
  }
];

export default function Brand1() {
  return (
  <section className="bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100 py-16">
         <h1 className="text-4xl md:text-5xl font-bold mb-8 font-bold text-center mb-12 text-black">
        Development Tools
      </h1>
      <div className="container mx-auto">
        <div className="-mx-4 flex flex-wrap">
          <div className="w-full px-4">
            <div className="flex flex-wrap items-center justify-center">
              {brandsData.map((brand, i) => (
                <motion.div
                animate={{ y: [0, -12, 0] }}
                transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
              >
                <SingleImage key={i} brand={brand} />
              </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const SingleImage = ({ brand }) => {
  const { link, imageSrc, lightImageSrc, altText, color } = brand;
  return (
    <a
      href={link}
      className="mx-4 flex w-[150px] items-center justify-center py-5 2xl:w-[180px]"
    >
      <img
        src={imageSrc}
        alt={altText}
        className="h-16 w-16"
      />
      <img
        src={lightImageSrc}
        alt={altText}
        className="hidden h-16 w-16"
      />
    </a>
  );
};
